//Should work if you place images in the right directory and number the image files according to the index
//following the structure of the galleries in the garage doors page
class LightboxGallery {
    galleryEl
    gallerySrc
    images
    index = 1
    img
    overlay
    navBtn
    closeBtn

    constructor(el) {
        this.galleryEl = el
        this.img = document.createElement('img')
        this.overlay = document.createElement('div')
        this.navBtn = {
            prev: document.createElement('button'),
            next: document.createElement('button')
        }
        this.closeBtn = document.createElement('button')

        this.img.className = 'gallery-display-img'
        this.overlay.className = 'modal-overlay'
        this.navBtn.prev.className = 'gallery-button gallery-button--prev'
        this.navBtn.next.className = 'gallery-button gallery-button--next'
        this.closeBtn.className = 'gallery-close-button'

        this.overlay.appendChild(this.img)
        this.overlay.appendChild(this.navBtn.prev)
        this.overlay.appendChild(this.navBtn.next)
        this.overlay.appendChild(this.closeBtn)
    }

    bindEvents() {
        this.images = this.galleryEl.querySelectorAll('div')
        this.gallerySrc = this.galleryEl.getAttribute('data-gallery-name')

        for (const image of this.images) {
            image.addEventListener('click', (e) => {
                this.displayLightbox()

                let imageIndex = parseInt(image.getAttribute('data-index'))

                this.index = imageIndex

                this.showImage(this.index, this.images)
            })
        }

        this.navBtn.prev.addEventListener('click', (e) => {
            e.preventDefault()
            this.prevImage()
        })
        this.navBtn.next.addEventListener('click', (e) => {
            e.preventDefault()
            this.nextImage()
        })
        this.closeBtn.addEventListener('click', (e) => {
            e.preventDefault()
            this.closeLightbox()
        })

        this.overlay.addEventListener('click', (e) => {
            if (e.target !== this.overlay) return

            this.closeLightbox()
        })
    }

    prevImage() {
        this.index -= 1
        this.showImage()
    }

    nextImage() {
        this.index += 1
        this.showImage()
    }

    showImage() {
        if (this.index > this.images.length) {
            this.index = 1
        } else if (this.index < 1) {
            this.index = this.images.length
        }

        this.img.setAttribute('src', `/img/webp/galleries/${this.gallerySrc}/${this.index}.webp`)
    }

    displayLightbox() {
        document.body.appendChild(this.overlay)
    }

    closeLightbox() {
        document.body.removeChild(this.overlay)
    }

}

const setupLightbox = () => {
    const galleries = document.querySelectorAll('[data-plugin-lightbox]')

    for (const gallery of galleries) {
        const lightBox = new LightboxGallery(gallery)
        lightBox.bindEvents()
    }
}

// Make function available globally
window.setupLightbox = setupLightbox;